const getTopDiscountByVenue = (venue: Venue.List | Venue.Detail) => {
    const discounts = venue?.discounts;
    if (!discounts || discounts.length === 0) return null;

    const topDiscount = discounts?.reduce((max, current) => {
        return max.percent > current.percent ? max : current;
    });
    return topDiscount.percent;
}

export default getTopDiscountByVenue;